import React, {useState} from "react";
import useTable from "../../hooks/useTable";
import TableFooter from "../TableFooter";
import {useTranslation} from "react-i18next";
import {RiLoader4Fill} from "react-icons/ri";


const Table = ({data, rowsPerPage, getFile, loading}) => {


    const {t} = useTranslation();
    const [page, setPage] = useState(1);
    const {slice, range} = useTable(data, page, rowsPerPage);

    return (<>
        <table className="others w-full min-w-max table-auto text-center text-lg">
            <thead className={"border-b-2"}>
            <tr className={"text-[#163578]"}>
                <th>{t('other.table.row1')}</th>
                <th className={"text-left"}>{t('other.table.row2')}</th>
                <th>{t('other.table.row3')}</th>
                <th>{t('other.table.row4')}</th>
            </tr>
            </thead>
            <tbody>
            {slice?.map((e, i) =>
                <tr key={i}>
                    <td>{i + 1}</td>
                    <td className={"text-left"}>{e.SURVEY_NAME}
                    </td>
                    <td>{e.SURVEY_DATE}</td>
                    <td className={"flex flex-row gap-2"}>
                        {e.IS_PDF === 1 ? (loading === 0 ? <img className={"cursor-pointer mx-auto"}
                                                                src="/images/other-download-pdf.png"
                                                                onClick={() => getFile(e.SURVEY_ID, e.SURVEY_NAME, 'pdf')}
                                                                alt={"Download pdf"}/> :
                            <RiLoader4Fill className={"animate-spin"}></RiLoader4Fill>) : <></>}
                        {e.IS_XLS === 1 ? (loading === 0 ? <img className={"cursor-pointer mx-auto"}
                                                                src="/images/other-download-xls.png"
                                                                onClick={() => getFile(e.SURVEY_ID, e.SURVEY_NAME, 'xlsx')}
                                                                alt={"Download xls"}/> :
                            <RiLoader4Fill className={"animate-spin"}></RiLoader4Fill>) : <></>}
                    </td>
                </tr>
            )}
            </tbody>
        </table>
        <TableFooter range={range} slice={slice} setPage={setPage} page={page}/>

    </>)
};

export default Table;